import moment from 'moment';
import { maxDate } from './maxDate';
import { germanDateFormat } from '@/utilities/germanFormats';

export const maxDate3Months = maxDate(
    moment().add(3, 'months').format(germanDateFormat),
);
